module.exports = __webpack_public_path__ + "static/media/hackathon.6ff6cbb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/images/logos/hackathon.jpg
// module id = 202
// module chunks = 0